import {EventEmitter, Injectable} from '@angular/core';
import {
  AuthGuard,
  MANAGE_ACCOUNT,
  MANAGE_ANALYSIS,
  MANAGE_AUDITS,
  MANAGE_FIRMWARE,
  MANAGE_GROUPS,
  MANAGE_MACHINES,
  MANAGE_MODELS,
  MANAGE_ORGANIZATIONS,
  MANAGE_USERS,
  VIEW_ALARMS
} from '../common/auth-guard.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private items: any[];
  private readonly zoneEmitterName: EventEmitter<string>;
  private readonly zoneEmitterNumberAlarms: EventEmitter<number>;


  constructor(private authGuard: AuthGuard) {
    this.zoneEmitterName = new EventEmitter<string>();
    this.zoneEmitterNumberAlarms = new EventEmitter<number>();
  }

  public getItems(): any[] {
    this.items = [];
    this.push({
      id: 'map',
      label: 'menu.map',
      icon: 'pi pi-map-marker',
      description: 'menu.descriptions.map',
      routerLink: '/map'
    });
    this.push({
      id: 'machines',
      label: 'menu.machines',
      icon: 'pi pi-wifi',
      description: 'menu.descriptions.machines',
      routerLink: '/machines'
    });
    this.pushIfHasPermission(MANAGE_MACHINES, {
      id: 'importCsv',
      label: 'menu.importCsv',
      icon: 'pi pi-file-excel',
      description: 'menu.descriptions.importCsv',
      routerLink: '/csv'
    });
    this.pushIfHasPermission(MANAGE_ANALYSIS, {
      id: 'analysis',
      label: 'menu.analysis',
      icon: 'pi pi-chart-bar',
      description: 'menu.descriptions.analysis',
      routerLink: '/analysis'
    });
    this.pushIfHasPermission(VIEW_ALARMS, {
      id: 'maintenance',
      label: 'menu.maintenance',
      icon: 'pi pi-exclamation-triangle',
      description: 'menu.descriptions.maintenance',
      routerLink: '/maintenance'
    });
    this.pushIfHasPermission(MANAGE_ORGANIZATIONS, {
      id: 'organizations',
      label: 'menu.organizations',
      icon: 'pi pi-sitemap',
      description: 'menu.descriptions.organizations',
      routerLink: '/organizations'
    });
    this.pushIfHasPermission(MANAGE_ORGANIZATIONS, {
      id: 'organizationTypes',
      label: 'menu.organizationTypes',
      icon: 'pi pi-th-large',
      description: 'menu.descriptions.organizationTypes',
      routerLink: '/organizationTypes'
    });
    this.pushIfHasPermission(MANAGE_GROUPS, {
      id: 'groups',
      label: 'menu.groups',
      icon: 'pi pi-tags',
      description: 'menu.descriptions.groups',
      routerLink: '/groups'
    });
    this.pushIfHasPermission(MANAGE_USERS, {
      id: 'users',
      label: 'menu.users',
      icon: 'pi pi-users',
      description: 'menu.descriptions.activity',
      routerLink: '/users'
    });
    this.pushIfHasPermission(MANAGE_MODELS, {
      id: 'models',
      label: 'menu.models',
      icon: 'pi pi-mobile',
      description: 'menu.descriptions.models',
      routerLink: '/models'
    });
    this.pushIfHasPermission(MANAGE_FIRMWARE, {
      id: 'firmware',
      label: 'menu.firmware',
      icon: 'pi pi-file',
      description: 'menu.descriptions.firmware',
      routerLink: '/firmware'
    });
    this.pushIfHasPermission(MANAGE_AUDITS, {
      id: 'audits',
      label: 'menu.audits',
      icon: 'pi pi-book',
      description: 'menu.descriptions.audits',
      routerLink: '/audits'
    });
    if (this.authGuard.isRoot()) {
      this.push({
        id: 'subscriptions',
        label: 'menu.subscriptions',
        icon: 'pi pi-cloud-upload',
        description: 'menu.descriptions.userSubscriptions',
        routerLink: '/subscriptions'
      });
    }
    this.pushIfHasPermission(MANAGE_ACCOUNT, {
      id: 'account',
      label: 'menu.account',
      icon: 'pi pi-user',
      description: 'menu.descriptions.account',
      routerLink: '/account'
    });

    return this.items;
  }

  public getZoneEmitterName(): EventEmitter<string> {
    return this.zoneEmitterName;
  }

  public getZoneEmitterNumberAlarms(): EventEmitter<number> {
    return this.zoneEmitterNumberAlarms;
  }

  private pushIfHasPermission(requiredPermission: any, item: any): void {
    if (this.authGuard.hasRequiredPermission(requiredPermission) === true) {
      this.items.push(item);
    }
  }

  private push(item: any): void {
    this.items.push(item);
  }

}
